export default "__VITE_ASSET__je0mfeHa__"